import styled from 'styled-components';
import {
  desktop_breakpoint_extended,
  desktop_container_maxwidth,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const FaqPageSectionStyles = styled.div`
  background-color: ${(props) => props.$styleProps.bgColor};

  .constrained-width {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: space-between;
    padding-top: 64px;
    padding-bottom: 64px;
  }

  .section-header {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 16px;
  }

  .section-intro {
    width: 100%;

    p {
      font-size: 14px;
      margin-bottom: 32px;
    }
  }

  a:link {
    text-decoration: none;
  }

  .faq-questions {
    list-style: none;
    padding-top: 28px;
  }

  .faq-question-link {
    font-weight: bold;
    padding-top: 32px;
    padding-bottom: 32px;
    border-bottom: 1px solid #cacccf;

    a {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    a:link,
    a:visited {
      color: black;
    }

    div > div {
      height: 100%;
      position: relative;
      width: 16px;
    }

    .faq-question-text {
      font-size: 18px;
      font-weight: 400;
      font-family: 'Acumin Pro', sans-serif;
      margin-right: 0.5em;
    }

    svg {
      margin-left: 0.2em;
      position: absolute;
      top: calc(50% - 12px);
      transition: all 0.1s ease-in-out 0s;
      transform: translateY(40%);

      path {
        fill: ${Colors.primary.claytonBlue.standard};
      }
    }

    &:hover {
      svg {
        transform: translate(30%, 40%);
      }
    }
  }

  .faq-category-link {
    display: inline-block;

    svg {
      margin-left: 0.3em;
      transition: all 0.1s ease-in-out 0s;
      transform: translateY(40%);
      vertical-align: top;

      path {
        fill: ${Colors.primary.claytonBlue.standard};
      }
    }

    &:hover {
      svg {
        transform: translate(30%, 40%);
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    margin-top: 96px;
    padding-bottom: 32px;
    display: flex;
    .section-left {
      width: 40%;
      padding-top: 32px;
    }

    .section-right {
      width: 60%;
      padding-top: 32px;
    }

    .faq-questions {
      list-style: none;
      padding-top: 0px;
      margin-top: -32px;
    }
  }

  @media screen and (min-width: ${desktop_container_maxwidth}px) {
    display: flex;
    .section-left {
      width: 40%;
    }

    .section-right {
      width: 60%;
    }

    .faq-questions {
      list-style: none;
      padding-top: 0px;
      margin-top: -32px;
    }
  }
`;
